import { Routes, Route, Navigate } from "react-router-dom";
import PermissionRoute from "./PermissionRoute";
import Settings from "../pages/Settings/Settings";

/* Shared */
import MyProfile from "../pages/Settings/MyProfile";
import RolePermission from "../pages/Settings/RolePermission";
import PasswordManagement from "../pages/Settings/PasswordManagement";
import NotificationSettings from "../pages/Settings/NotificationSettings";
import AttendanceSettings from "../pages/Settings/AttendanceSettings";
import MyLeaveRequests from "../pages/Settings/Leaves/MyLeaveRequests";
import BackgroundsSettings from "../features/backgrounds/BackgroundsSettings";
import PersonaliseDashboard from "../pages/Settings/PersonaliseDashboard";

/* Admin + HR */
import CompanyInformation from "../pages/Settings/CompanyInformation";
import LetterTemplates from "../pages/Settings/LetterTemplates/LetterTemplates";
import CreateTemplate from "../pages/Settings/LetterTemplates/CreateTemplate";
import EditTemplate from "../pages/Settings/LetterTemplates/EditTemplate";
import CalendarSettings from "../pages/Settings/CalendarSettings";
import ShiftManagement from "../pages/Settings/Shifts/ShiftManagement";

/* Admin only or privileged */
import DepartmentManagement from "../pages/Settings/DepartmentManagement";
import JobTitleManagement from "../pages/Settings/JobTitleManagement";
import EmployeeTypesManagement from "../pages/Settings/EmployeeTypesManagement";
import WorkLocationsManagement from "../pages/Settings/WorkLocationsManagement";
import EmploymentStatusesManagement from "../pages/Settings/EmploymentStatusesManagement";
import MasterDataManagement from "../pages/Settings/MasterDataManagement";
import ProfileGeneratorSettings from "../pages/Settings/ProfileGeneratorSettings";

const SettingsRoutes = () => {
  const role = (localStorage.getItem("role") || "").toLowerCase().trim();
  const defaultPath =
    role === "member" ? "password-management" : "company-info";

  return (
    <Routes>
      <Route element={<Settings />}>
        <Route index element={<Navigate to={defaultPath} replace />} />

        {/* Shared */}

        <Route
          path="notifications"
          element={
            <PermissionRoute permission="view_settings">
              <NotificationSettings />
            </PermissionRoute>
          }
        />

        <Route
          path="attendance"
          element={
            <PermissionRoute permission="view_settings">
              <AttendanceSettings />
            </PermissionRoute>
          }
        />

        {/* Admin + HR type access */}
        <Route
          path="company-info"
          element={
            <PermissionRoute permission="manage_company_info">
              <CompanyInformation />
            </PermissionRoute>
          }
        />

        <Route
          path="letter-templates"
          element={
            <PermissionRoute permission="manage_letter_templates">
              <LetterTemplates />
            </PermissionRoute>
          }
        />

        <Route
          path="letter-templates/create"
          element={
            <PermissionRoute permission="manage_letter_templates">
              <CreateTemplate />
            </PermissionRoute>
          }
        />

        <Route
          path="letter-templates/edit/:id"
          element={
            <PermissionRoute permission="manage_letter_templates">
              <EditTemplate />
            </PermissionRoute>
          }
        />

        <Route
          path="calendar"
          element={
            <PermissionRoute permission="manage_calendar_settings">
              <CalendarSettings />
            </PermissionRoute>
          }
        />

        <Route
          path="shift-management"
          element={
            <PermissionRoute permission="view_settings">
              <ShiftManagement />
            </PermissionRoute>
          }
        />

        <Route
          path="my-profile"
          element={
            <PermissionRoute permission="view_settings">
              <MyProfile />
            </PermissionRoute>
          }
        />

        <Route
          path="password-management"
          element={
            <PermissionRoute permission="view_settings">
              <PasswordManagement />
            </PermissionRoute>
          }
        />

        <Route
          path="roles-access"
          element={
            <PermissionRoute permission="manage_roles_permissions">
              <RolePermission />
            </PermissionRoute>
          }
        />

        {/* More restricted settings */}
        <Route
          path="departments"
          element={
            <PermissionRoute permission="view_settings">
              <DepartmentManagement />
            </PermissionRoute>
          }
        />

        <Route
          path="job-titles"
          element={
            <PermissionRoute permission="view_settings">
              <JobTitleManagement />
            </PermissionRoute>
          }
        />

        <Route
          path="employee-types"
          element={
            <PermissionRoute permission="view_settings">
              <EmployeeTypesManagement />
            </PermissionRoute>
          }
        />

        <Route
          path="work-locations"
          element={
            <PermissionRoute permission="view_settings">
              <WorkLocationsManagement />
            </PermissionRoute>
          }
        />

        <Route
          path="employment-statuses"
          element={
            <PermissionRoute permission="view_settings">
              <EmploymentStatusesManagement />
            </PermissionRoute>
          }
        />

        <Route
          path="masterdata"
          element={
            <PermissionRoute permission="view_settings">
              <MasterDataManagement />
            </PermissionRoute>
          }
        />

        <Route
          path="profile-generator"
          element={
            <PermissionRoute permission="manage_profile_generator">
              <ProfileGeneratorSettings />
            </PermissionRoute>
          }
        />

        {/* Appearance */}
        <Route
          path="personalise"
          element={
            <PermissionRoute permission="view_settings">
              <PersonaliseDashboard />
            </PermissionRoute>
          }
        />

        <Route
          path="backgrounds"
          element={
            <PermissionRoute permission="view_settings">
              <BackgroundsSettings />
            </PermissionRoute>
          }
        />

        {/* Member/self */}
        <Route
          path="my-leave-requests"
          element={
            <PermissionRoute permission="apply_leave">
              <MyLeaveRequests />
            </PermissionRoute>
          }
        />
      </Route>
    </Routes>
  );
};

export default SettingsRoutes;
